import { useMemo } from 'react'
import { type FeatureId, Logger } from '@terros/common'
import { type FeatureCheckHookInput, type FeatureState, useFeature } from '@front/model'

const logger = new Logger('useFeature')

export function useFeatureWithOverride(input: FeatureCheckHookInput): FeatureState {
  const response = useFeature(input)

  const override = useMemo(() => {
    return getFeatureOverride(input.featureId)
  }, [input.featureId])

  if (override !== undefined) {
    return {
      isLoading: false,
      isEnabled: override,
    }
  }

  return response
}

const getFeatureOverride = (feature: FeatureId): boolean | undefined => {
  if (!import.meta.env.DEV) return
  const override = overrides.get(feature)

  if (override !== undefined) logger.warn(`Feature override for ${feature} is ${override}`)

  return override
}

const overrides = new Map<FeatureId, boolean>([
  ['Feature:AccountTableBulkAction', true],
  ['Feature:WorkflowHidePreviousActivity', true],
  ['Feature:WorkflowPreActions', true],
  ['Feature:WorkflowSetterCloserConfig', true],
  ['Feature:CalendarStackIdenticalEvents', true],
  ['Feature:TeamHierarchyFocusView', true],
  ['Feature:CustomLocationManagement', true],
])
